export default {
  menuClickControlModalData: {},
  catalogModalDeleteRowId: null,
};
